module.exports = __webpack_public_path__ + "static/homeScreenBanner4-8397c467351ea6975c22f7fc3bbe3513.png";